import type { TOC } from '@ember/component/template-only';

interface Signature {
  Args: {};
}

const ItemsIndexResultsLoading: TOC<Signature> = <template>
  <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
    <div class="bg-base-100 rounded-box p-4 shadow">
      <div class="skeleton mb-3 h-36 w-full"></div>
      <div class="skeleton mb-2 h-5 w-3/4"></div>
      <div class="skeleton mb-2 h-4 w-1/2"></div>
      <div class="skeleton h-4 w-2/3"></div>
    </div>
    <div class="bg-base-100 rounded-box p-4 shadow">
      <div class="skeleton mb-3 h-36 w-full"></div>
      <div class="skeleton mb-2 h-5 w-2/3"></div>
      <div class="skeleton mb-2 h-4 w-1/3"></div>
      <div class="skeleton h-4 w-3/4"></div>
    </div>
    <div class="bg-base-100 rounded-box p-4 shadow">
      <div class="skeleton mb-3 h-36 w-full"></div>
      <div class="skeleton mb-2 h-5 w-4/5"></div>
      <div class="skeleton mb-2 h-4 w-2/5"></div>
      <div class="skeleton h-4 w-1/2"></div>
    </div>
  </div>

  <div class="mt-8 flex justify-center">
    <div class="bg-base-100 rounded-box h-10 w-56 shadow">
      <div class="skeleton h-full w-full"></div>
    </div>
  </div>
</template>;

export default ItemsIndexResultsLoading;
